import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const AdminReports = React.lazy(
    () => import(/* webpackChunkName: "admin-reports" */ '../../../../containers/Admin/Reports')
);
const AdminReportsTable = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-reports-table" */ '../../../../containers/Admin/Reports/children/ReportsTable'
        )
);
const AdminReportHistory = React.lazy(
    () => import(/* webpackChunkName: "admin-report-history" */ '../../../../containers/Admin/Reports/children/History')
);

export const AdminReportsRoutes: RouteObject = {
    path: 'reports',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminReports />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <AdminReportsTable />
                </React.Suspense>
            )
        },
        {
            path: 'report/:reportId/history',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <AdminReportHistory />
                </React.Suspense>
            )
        }
    ]
};
